import bets from "../assets/gameInterface/info_bets.png";
import settings from "../assets/gameInterface/info_settings.png";
import info from "../assets/gameInterface/info_info.png";
import fast from "../assets/gameInterface/info_fast.png";
import auto from "../assets/gameInterface/info_auto.png";
import spin from "../assets/gameInterface/info_spin.png";
import betAmount from "../assets/gameInterface/info_betamount.png";
import { GameConfigs } from "../../lib/globals/GameConfigs";

export default function GameInterface({ currentBet, currency }) {
  return (
    <div className="wrapper">
      <div className="content">
        <div className="title">MAIN GAME INTERFACE</div>
      </div>
      <div className="interface_wrapper">
        <div
          className="description interface_description"
          style={{ flexWrap: "wrap" }}
        >
          <div
            className="description_icon"
            style={{
              marginLeft: "4px",
            }}
          >
            <img src={bets} alt="bets" />
          </div>
          <span>
            - You can configure the desired bet amount by clicking the
            increasing and decreasing buttons.
          </span>
        </div>
        <div
          className="description interface_description"
          style={{ flexWrap: "wrap" }}
        >
          <div className="description_icon">
            <img
              src={betAmount}
              alt="bets"
              style={{
                width: "276px",
                marginLeft: "-12px",
              }}
            />
          </div>
          <span className="interface_betamount_currency">
            BET AMOUNT ({currency})
          </span>
          <span className="interface_betamount">
            {(+currentBet).toLocaleString(undefined, {
              minimumFractionDigits: GameConfigs.config.currency_prec,
              maximumFractionDigits: GameConfigs.config.currency_prec,
            })}
          </span>
          <span>
            - The configured bet amount with currency symbol or abbreviation.
          </span>
        </div>
        <div className="description interface_description">
          <div className="description_icon">
            <img src={settings} alt="bets" />
          </div>
          <span>
            - Opens the Settings menu, which contains settings that affect how
            the game is played.
          </span>
        </div>
        <div className="description interface_description">
          <div className="description_icon">
            <img src={info} alt="bets" />
          </div>
          <span>- Opens the information page.</span>
        </div>
        <div className="description interface_description">
          <div className="description_icon">
            <img src={fast} alt="bets" />
          </div>
          <span>- Turn On/Off fast play mode.</span>
        </div>
        <div className="description interface_description">
          <div className="description_icon">
            <img src={auto} alt="bets" />
          </div>
          <span>- Opens auto play configuration page</span>
        </div>
        <div className="description interface_description">
          <div className="description_icon" style={{ marginLeft: "10px" }}>
            <img src={spin} alt="bets" />
          </div>
          <span style={{ marginLeft: "10px" }}>- Start game</span>
        </div>
      </div>
    </div>
  );
}
